module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product', {
    attrs: {
      "title": "Hellast / Full load"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\n            P. Pedersen & Søn kan håndtere én eller flere afhentninger op til 38 tons pr. gang.\n        ")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "product-image",
    staticStyle: {
      "width": "400px",
      "max-width": "100%"
    },
    attrs: {
      "src": "/static/images/fullload.jpg"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e34d3bce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/products/hellast.vue
// module id = 280
// module chunks = 1